import { User } from '../AuthContext';

/**
 * Get the default redirect path for a user after auth actions.
 * - Users with verified brands → first verified brand page (using slug)
 * - Users without verified brands → homepage
 * - Future: SuperAdmin logic can be added here
 */
export const getDefaultRedirect = (user: User | null): string => {
  console.log('getDefaultRedirect called with user:', user?.email, 'brands:', user?.brands?.length);
  if (user?.brands && user.brands.length > 0) {
    console.log('Brands:', user.brands.map(b => ({ name: b.name, slug: b.slug, verified: b.verified })));
    // Find the first verified brand with a slug
    const verifiedBrand = user.brands.find(brand => brand.verified && brand.slug);
    console.log('Found verified brand:', verifiedBrand?.name, verifiedBrand?.slug);
    if (verifiedBrand) {
      return `/${verifiedBrand.slug}`;
    }
  }
  return '/';
};
